import { Component, OnInit } from '@angular/core';
import {animationsTable} from '../../../common-page-components/wa-table/wa-table.component';

@Component({
  selector: 'app-indoor-elite-bootstrap',
  templateUrl: './indoor-elite-bootstrap.component.html',
  styleUrls: ['./indoor-elite-bootstrap.component.scss'],
})
export class IndoorEliteBootstrapComponent implements OnInit {
  interpretation_expanded = false

  constructor() { }

  ngOnInit() {
  }

}
